export default __webpack_public_path__ + "static/media/frontdesk-room-view.3321520e.webp";